import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import Button from '../../../../components/atoms/Button/Button';
import ButtonGris from '../../../../components/atoms/ButtonGris/ButtonGris';
import InputLista from '../../../../components/atoms/InputLista/InputLista';
import InputTextMy from '../../../../components/atoms/InputText/InputText';
import { editarIncidenciaGeneral, getEfectos } from '../CierreDeTurnoIntegracion';
import Swal from 'sweetalert2';
import '../CierreDeTurno.scss';

const EditarIncidenciaGeneral = ({ visible, onHide, row, causas = [], onGuardado, userData }) => {
    const [form, setForm] = useState({ causa: null, efecto: null, detalle: '' });
    const [efectosFiltrados, setEfectosFiltrados] = useState([]);
    const [guardando, setGuardando] = useState(false);
    console.log("form",form);
    
    /* Precarga los valores del row al abrir: trae los efectos de la causa ya asignada */
    useEffect(() => {
        if (visible && row) {
            if (row.ID_CAUSA) {
                getEfectos(row.ID_CAUSA).then((res) => {
                    const lista = res ?? [];
                    setEfectosFiltrados(lista);
                    console.log("lista",lista);
                    console.log("row.ID_EFECTO",row.ID_EFECTO);
                    
                    setForm({
                        causa: causas.find((c) => c.code === row.ID_CAUSA) ?? null,
                        efecto: lista.find((e) => e.code == row.ID_EFECTO) ?? null,
                        detalle: row.DETALLE ?? '',
                    });
                });
            } else {
                setEfectosFiltrados([]);
                setForm({ causa: null, efecto: null, detalle: row.DETALLE ?? '' });
            }
        }
    }, [visible, row, causas]);
  
    /* Cuando el usuario cambia la causa, recarga los efectos y limpia el efecto actual */
    const handleCausaChange = (e) => {
        const nuevaCausa = e.value;
        setForm((f) => ({ ...f, causa: nuevaCausa, efecto: null }));
        if (nuevaCausa?.code) {
            getEfectos(nuevaCausa.code).then((res) => setEfectosFiltrados(res ?? []));
        } else {
            setEfectosFiltrados([]);
        }
    };

    const handleGuardar = async () => {
        if (!row) return;
        setGuardando(true);
        const params = {
            id: row.ID,
            id_causa: form.causa?.code ?? null,
            id_efecto: form.efecto?.code ?? null,
            detalle: form.detalle,
            editado_por: userData?.ID ?? null, // TODO: Reemplazar con userData real
        }
        try {


            await editarIncidenciaGeneral(params).then(() => {
                Swal.fire({ icon: 'success', title: 'Incidencia actualizada' });
            })
                .catch(() => {
                    Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo actualizar la incidencia.' });
                });
            onGuardado?.();
            onHide();
        } catch {
            Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo guardar la edición.' });
        } finally {
            setGuardando(false);
        }
    };

    return (
        <Dialog
            visible={visible}
            onHide={onHide}
            header="Editar Incidencia General"
            className="modalDashboard"
            style={{ width: '480px' }}
            modal
        >
            <div className="formIncidencia">
                <InputLista
                    titulo="Causa"
                    value={form.causa}
                    onChange={handleCausaChange}
                    options={causas}
                    optionLabel="name"
                    placeholder="Seleccione una causa..."
                    obligatory={false}
                    className="formIncidencia__campo"
                />
                <InputLista
                    titulo="Efecto"
                    value={form.efecto}
                    onChange={(e) => setForm((f) => ({ ...f, efecto: e.value }))}
                    options={efectosFiltrados}
                    optionLabel="name"
                    placeholder="Seleccione un efecto..."
                    obligatory={false}
                    className="formIncidencia__campo"
                />
                <InputTextMy
                    title="Detalle"
                    value={form.detalle}
                    onChange={(e) => setForm((f) => ({ ...f, detalle: e.target.value }))}
                    obligatorio={false}
                    className="formIncidencia__campo"
                    placeholder="Detalle de la incidencia..."
                />
                <div className="formIncidencia__acciones">
                    <Button
                        onClick={handleGuardar}
                        width="fit-content"
                        disabled={guardando}
                    >
                        {guardando ? 'Guardando...' : 'Guardar'}
                    </Button>
                    <ButtonGris onClick={onHide} width="fit-content">
                        Cancelar
                    </ButtonGris>
                </div>
            </div>
        </Dialog>
    );
};

export default EditarIncidenciaGeneral;
